import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const plans = [
  {
    name: 'Старт',
    channels: '10 каналов',
    price: '990 ₽',
    period: '/ месяц',
    features: [
      'AI-рассыльщик на 10 канал',
      'Автоматические первые сообщения',
      'Ведение диалогов 24/7',
      'Квалификация лидов',
      'Передача в CRM',
      'Базовая аналитика',
    ],
    highlighted: false,
  },
  {
    name: 'Бизнес',
    channels: '20 каналов',
    price: '4 990 ₽',
    period: '/ месяц',
    features: [
      'AI-рассыльщик на 20 каналов',
      'Всё из тарифа Старт',
      'Приоритетная обработка диалогов',
      'Расширенная аналитика',
      'A/B тестирование скриптов',
      'Персональный менеджер',
    ],
    highlighted: true,
  },
  {
    name: 'Максимум',
    channels: '40 каналов',
    price: '14 990 ₽',
    period: '/ месяц',
    features: [
      'AI-рассыльщик на 40 каналов',
      'Всё из тарифа Бизнес',
      'Кастомные AI-сценарии',
      'Интеграция с любыми CRM',
      'Выделенный сервер',
    ],
    highlighted: false,
  },
];

export default function ASPricing() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(3);

  return (
    <section id="as-pricing" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16 max-w-[640px]">
          <span ref={labelRef} className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Тарифы
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Выберите тариф
            <br />
            под ваши задачи
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {plans.map((plan, i) => (
            <div
              key={plan.name}
              className={`rounded-2xl border-2 p-6 md:p-7 flex flex-col reveal-fade-up ${i < cardsRevealed ? 'revealed' : ''} ${
                plan.highlighted
                  ? 'border-primary-500 bg-primary-50/30 relative'
                  : 'border-background-200/70 bg-background-50'
              }`}
              style={i < cardsRevealed ? { transitionDelay: `${i * 150}ms` } : undefined}
            >
              {plan.highlighted && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 text-xs font-semibold rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                  Популярный
                </span>
              )}

              <div className="mb-6">
                <p className="text-sm font-medium text-foreground-500 mb-1">{plan.channels}</p>
                <h3 className="font-display font-bold text-[18px] text-foreground-950">{plan.name}</h3>
              </div>

              <div className="mb-6">
                <span className="text-3xl md:text-4xl font-extrabold text-foreground-950">
                  {plan.price}
                </span>
                <span className="text-[14px] text-foreground-500 ml-1">{plan.period}</span>
              </div>

              <ul className="space-y-3 mb-8 flex-1">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-[14px] text-foreground-700">
                    <i className="ri-check-line text-primary-500 mt-0.5 shrink-0"></i>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="https://lk.aigam.ru"
                className={`block w-full h-12 inline-flex items-center justify-center text-[15px] font-semibold rounded-md text-center transition-colors whitespace-nowrap cursor-pointer ${
                  plan.highlighted
                    ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                    : 'border border-foreground-200 text-foreground-900 hover:bg-foreground-50'
                }`}
              >
                Выбрать {plan.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}